import { useEffect, useRef } from "react";
import {
  createNetworkStatusMonitor,
  type NetworkStatusMonitor,
  type NetworkStatusInfo,
} from "@/infra/tauri/networkStatusMonitor";
import { loggerService } from "@akina/infra";
import { useIsOffline } from "@akina/presentation";

const LOGGING_DOMAIN = "[network-status-monitor]";

export function useNetworkStatusMonitor() {
  const networkStatusMonitorRef = useRef<NetworkStatusMonitor | null>(null);
  const setIsOffline = useIsOffline(state => state.setIsOffline);

  const handlerRef = useRef<(info: NetworkStatusInfo) => void>(() => {});

  useEffect(() => {
    handlerRef.current = (info: NetworkStatusInfo) => {
      try {
        setIsOffline(!info.isOnline);
      } catch (error) {
        loggerService.warn(LOGGING_DOMAIN, "Failed to update network status:", error);
      }
    };
  }, [setIsOffline]);

  useEffect(() => {
    try {
      networkStatusMonitorRef.current = createNetworkStatusMonitor(info => handlerRef.current(info));
      networkStatusMonitorRef.current.start();
    } catch (error) {
      loggerService.warn(LOGGING_DOMAIN, "Failed to start network status monitor:", error);
      networkStatusMonitorRef.current = null;
    }

    return () => {
      try {
        networkStatusMonitorRef.current?.stop();
      } catch (error) {
        loggerService.warn(LOGGING_DOMAIN, "Error stopping network status monitor:", error);
      }
    };
  }, []);
}
